/* Homepage categories only; replaces carousel-slider for this section. */
if (!customElements.get('middo-category-slider')) {
  customElements.define('middo-category-slider', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.slider = this.querySelector('.slider');
      if (!this.slider) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const on = (type, handler, options = {}) => this.addEventListener(type, handler, { ...options, signal });
      const finish = () => {
        if (!this.pointer) return;
        const id = this.pointer.id;
        this.pointer = null;
        this.slider.classList.remove('is-grabbing');
        if (this.slider.hasPointerCapture(id)) this.slider.releasePointerCapture(id);
      };
      on('pointerdown', e => {
        if (e.isPrimary) this.suppressClick = false;
        if (e.pointerType !== 'mouse' || e.button !== 0 || !e.isPrimary || !this.slider.contains(e.target)) return;
        this.pointer = { id: e.pointerId, x: e.clientX, scroll: this.slider.scrollLeft };
      });
      on('pointermove', e => {
        const p = this.pointer;
        if (!p || p.id !== e.pointerId) return;
        if (!(e.buttons & 1)) { finish(); return; }
        const distance = e.clientX - p.x;
        if (!this.suppressClick && Math.abs(distance) < 6) return;
        if (!this.suppressClick) {
          this.suppressClick = true;
          this.slider.setPointerCapture(p.id);
          this.slider.classList.add('is-grabbing');
        }
        e.preventDefault();
        this.slider.scrollLeft = p.scroll - distance;
      });
      on('pointerup', finish);
      on('pointercancel', finish);
      on('lostpointercapture', finish);
      on('dragstart', e => { if (this.slider.contains(e.target)) e.preventDefault(); });
      on('click', e => {
        if (this.suppressClick && e.detail !== 0 && this.slider.contains(e.target)) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, { capture: true });
      on('click', e => {
        const button = e.target.closest('.slider-nav__btn');
        if (!button || button.disabled) return;
        const items = this.querySelectorAll('.slider__item');
        const step = items.length > 1 ? Math.abs(items[1].offsetLeft - items[0].offsetLeft) : this.slider.clientWidth;
        const direction = button.name === 'next' ? 1 : -1;
        this.slider.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
      const update = () => {
        const max = this.slider.scrollWidth - this.slider.clientWidth;
        this.toggleAttribute('inactive', max < 2);
        this.querySelector('[name="prev"]').disabled = this.slider.scrollLeft <= 1;
        this.querySelector('[name="next"]').disabled = this.slider.scrollLeft >= max - 1;
      };
      this.slider.addEventListener('scroll', update, { passive: true, signal });
      this.observer = new ResizeObserver(update);
      this.observer.observe(this.slider);
      this.observer.observe(this.querySelector('.slider__grid'));
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.pointer = null;
    }
  });
}
